<template>
  <v-list-item
    :dense="dense"
    :class="{ 'px-3': dense }"
    :to="to ?? undefined"
    @click="$emit('click')"
    :disabled="disabled"
  >
    <v-list-item-avatar class="mr-2">
      <v-icon v-if="icon" v-text="src" :color="color"></v-icon>
      <v-img v-else contain :src="src"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title
        v-html="title"
        class="text-wrap font-weight-bold text-body-2"
      ></v-list-item-title>
      <v-list-item-subtitle
        v-if="subtitle"
        v-html="subtitle"
        class="text-wrap font-weight-regular"
      ></v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";
import {
  // Firestore
  firestore,
  collection,
  getDocs,
  where,
  query,
  getDoc,
  doc,
  onSnapshot,
  // Functions
  functions,
  httpsCallable,
  // Remote Config
  remoteConfig,
  getValue,
} from "@/firebase/init";
// Components
import moment from "moment-timezone";

export default {
  name: "AvatarListCell",
  props: {
    icon: {
      default: false,
      type: Boolean,
      required: false,
    },
    dense: {
      default: false,
      type: Boolean,
      required: false,
    },
    to: {
      default: undefined,
      type: [Object],
      required: false,
    },
    src: {
      default: "Title",
      type: String,
      required: true,
    },
    title: {
      default: "",
      type: String,
      required: true,
    },
    subtitle: {
      default: "",
      type: String,
      required: false,
    },
    color: {
      default: "secondaryIcon",
      type: String,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  data: () => ({}),
};
</script>

<style></style>
